<template>
  <footer class="footer">
    <div class="footer__grid">
      <!-- 品牌区 -->
      <div class="footer__brand">
        <img :src="logoSrc" alt="YWG" class="footer__logo" />
        <p class="footer__desc">
          广东省南方文化产权交易所官方平台。以矩阵式方式承接文化产权、交易服务与地方文化礼赠展示。
        </p>
        <p class="footer__copyright">
          © 2026 粤文购 版权所有 | 粤ICP备11002111号
        </p>
      </div>

      <!-- 右侧区 -->
      <div class="footer__right">
        <!-- 导航 + 联系 -->
        <div class="footer__top-row">
          <div class="footer__col">
            <h4 class="footer__col-title">导航入口</h4>
            <div class="footer__nav-list">
              <div
                v-for="item in navItems"
                :key="item.label"
                class="footer__nav-group"
              >
                <span
                  class="footer__nav-label"
                  @click="item.name && onNavigate(item.name)"
                  >{{ item.label }}</span
                >
                <template v-if="item.children">
                  <span
                    v-for="child in item.children"
                    :key="child"
                    class="footer__nav-child"
                    >{{ child }}</span
                  >
                </template>
              </div>
            </div>
          </div>

          <div class="footer__col">
            <h4 class="footer__col-title">联系与合作</h4>
            <div class="footer__contact">
              <span>contact@yuewengou.cn</span>
              <span>020-0000-0000</span>
              <span>广州 · 官方合作咨询入口</span>
            </div>
          </div>
        </div>

        <!-- 二维码区 -->
        <div class="footer__qrcodes">
          <div v-for="qr in qrcodes" :key="qr.label" class="footer__qr-item">
            <div class="footer__qr-img">
              <img :src="qr.image" :alt="qr.label" />
            </div>
            <span class="footer__qr-label">{{ qr.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import logoSrc from "@/assets/images/YWG_logo03.png";

export default {
  name: "Footer",
  data() {
    return {
      logoSrc,
      navItems: [
        { label: "首页", name: "Home" },
        { label: "数据监控平台", name: "bigScreen" },
        {
          label: "展会服务",
          children: ["展商专区", "交易专区", "活动专区"],
        },
        { label: "技术服务", children: ["版权服务", "溯源服务"] },
        { label: "广东礼物", name: "Gift" },
      ],
      qrcodes: [
        {
          label: "广东礼物",
          image: require("@/assets/images/icon_QRcode.png"),
        },
        {
          label: "数遗光年",
          image: require("@/assets/images/icon_QRcode.png"),
        },
        {
          label: "数据监控平台",
          image: require("@/assets/images/icon_QRcode.png"),
        },
        {
          label: "粤文购",
          image: require("@/assets/images/icon_QRcode.png"),
        },
      ],
    };
  },
  methods: {
    onNavigate(name) {
      if (name === "bigScreen") {
        window.open("https://www.yuewengou.com/bigScreen/", "_blank");
        return;
      }
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.footer {
  background-color: #0e2746;
  padding: 40px;
  box-sizing: border-box;
  max-width: 1680px;
  margin: 0 auto;

  &__grid {
    display: flex;
    justify-content: space-between;
    gap: 22px;
    margin: 0 auto;
  }

  // ---- 品牌区 ----
  &__brand {
    width: 430px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__logo {
    width: 129px;
    height: 38px;
    object-fit: contain;
  }

  &__desc {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #ffffffb8;
    line-height: 1.74;
    margin: 0;
    text-align: left;
  }

  &__copyright {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #ffffffb8;
    line-height: 1.74;
    margin: 0;
    text-align: left;
  }

  // ---- 右侧区 ----
  &__right {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-end;
  }

  &__top-row {
    display: flex;
    gap: 100px;
    align-items: flex-start;
  }

  &__col {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__col-title {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #d7c08f;
    letter-spacing: 1.2px;
    margin: 0;
    text-align: left;
  }

  // ---- 导航列表 ----
  &__nav-list {
    display: flex;
    gap: 30px;
  }

  &__nav-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__nav-label {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #ffffff;
    line-height: 1.84;
    cursor: pointer;
    text-align: left;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  &__nav-child {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #ffffffd9;
    line-height: 1.84;
    text-align: left;
    display: block;
  }

  // ---- 联系信息 ----
  &__contact {
    display: flex;
    flex-direction: column;

    span {
      font-family: $font-family;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
      line-height: 1.84;
      text-align: left;
    }
  }

  // ---- 二维码区 ----
  &__qrcodes {
    display: flex;
    gap: 34px;
  }

  &__qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  &__qr-img {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__qr-label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #ffffffd9;
    line-height: 1.84;
  }

  // ---- 平板适配 ----
  @include tablet {
    padding: 32px;

    &__brand {
      width: 340px;
    }

    &__top-row {
      gap: 60px;
    }

    &__nav-list {
      gap: 20px;
    }
  }

  // ---- 手机适配 ----
  @include mobile {
    padding: 40px 20px;

    &__grid {
      flex-direction: column;
      gap: 30px;
    }

    &__brand {
      width: 100%;
    }

    &__right {
      align-items: flex-start;
    }

    &__top-row {
      flex-direction: column;
      gap: 24px;
    }

    &__nav-list {
      flex-wrap: wrap;
      gap: 16px;
    }

    &__qrcodes {
      flex-wrap: wrap;
      gap: 20px;
    }
  }
}
</style>
